import { MoreVert } from '@material-ui/icons'
import { Delete, Edit, Update,Check, } from '@mui/icons-material'
import React, { useState } from 'react'
import { useContext, useEffect} from 'react'
import { Dropdown } from 'react-bootstrap'
import { Pending } from '@mui/icons-material';
import { connect, useDispatch } from 'react-redux';
import AdminUpdateSupportRequest from '../../actions/support/AdminUpdateSuppportRequest';
import { AuthContext } from '../../context/AuthContext';
import FetchCustomerTickets from "../../actions/support/FetchCustomerTickets";
import Localbase from "localbase"
import StatusChip from '../../components/StatusChip';
import defaultUser from '../../assets/images/users/user-dummy-img.jpg'


const HackingInternshipRegistrationItem = ({item,SelectUser,Reload,storedata,options}) => {
    const [show,setshow] = useState(false)

    const HandleClose = ()=>{

setshow(false)

    }
    const HandleDelete = ()=>{



    }

    const [edit,setedit] = useState(false)
    const CloseEdit = ()=>{

        setedit(false)
    }
    const [selected,setselected] = useState(false)


    const { user } = useContext(AuthContext)
    const dispatch = useDispatch()
     const [toastdata, setoastdata] = useState(null)

    const UpdateRequest = async ({ status }) => {
      try {
        dispatch({ type: 'LOADING' });
        const res = await AdminUpdateSupportRequest({
          payload: {
            session: user.SessionId,
            id: item.id,
            status: status,
            notification: storedata.sendNotification.notification
          }
        })
        if (res) {
          setoastdata(res.data)
          if (res.status === "success") {
            Reload()
            dispatch({ type: 'DONE_LOADING', payload: 'Update failed' });
  
          }
          else {
            dispatch({ type: 'ERROR', payload: 'Update failed' });
          }
  
        }
      }
      catch (error) {
        dispatch({ type: 'ERROR', payload: error.message });
      }
    }

    const db = new Localbase("db")
    const [limit, setlimit] = useState(100)
    const [doubts, setdoubts] = useState(null)

    const FetchCustomerRequests = async () => {

      try{
        dispatch({type:"LOADING"})
        const res = await FetchCustomerTickets({
          payload:
            { SessionId: user.SessionId, limit: options.limit || limit }
        }
        )
    
        if (res) {
    
          dispatch({type: "DONE_LOADING" })
          db.collection("paths").add({ customer_tickets: res.data }, "customer_tickets")
          setdoubts(res.data)
          console.log(res);
    
        }else{
          dispatch({type:"ERROR", payload: res.error.message})
        }
      }catch(error){
     dispatch({type:"ERROR", payload: error.message})
      }
    
    }

    useEffect(() => {
      db.collection("paths").doc("customer_tickets").get().then(data => {
        if (data) {
          setdoubts(data.customer_tickets)
        } 
      })
      FetchCustomerRequests()
    }, [])
  return (
  
  <>


  <tr>
                            {/* <th scope="row">
                              <div className="form-check">
                                <input
checked={selected}
                                  className="form-check-input"
                                  type="checkbox"
                                  name="checkAll"
                                  onClick={()=>{SelectUser();setselected(!selected)}}
                                  defaultValue="option1"
                                />
                              </div>
                            </th> */}
                          
                            <td className="customer_name">{item.name}</td>
                            <td className="product_name">{item.phone_number}</td>
                            <td className="date">
                              {item.email}
                              </td>
                            <td className="amount">{item.create_datetime}</td>
                         
                            <td className="status">
                              <span className="badge bg-warning-subtle text-warning text-uppercase">
                              <StatusChip item={item} />
                  {(item.status === "closed" || item.status === "initiated") ? (
                    <div className="d-flex align-items-center justify-content-end">
                      <img
                      src={item.support_pic ? item.support_pic : defaultUser}
                      alt=""
                      className="member-img img-fluid d-block rounded-5 col-2"
                    />
                    <p className="text-muted mb-0 ms-1">{item?.resolved_by_name ? item?.resolved_by_name : 'support team'}</p>
                    </div>
                  ) : null}
                              </span>
                            </td>
                            {/* <td>
                              <ul className="list-inline hstack gap-2 mb-0">
                                <li
                                  className="list-inline-item"
                                  data-bs-toggle="tooltip"
                                  data-bs-trigger="hover"
                                  data-bs-placement="top"
                                  title="View"
                                >
                                  <a
                                    href="apps-ecommerce-order-details.html"
                                    className="text-primary d-inline-block"
                                  >
                                    <i className="ri-eye-fill fs-16" />
                                  </a>
                                </li>
                                <li
                                  className="list-inline-item edit"
                                 onClick={()=>setedit(true)}
                                  title="Edit"
                                >
                                  <a
                          
                                    className="text-primary d-inline-block edit-item-btn"
                                  >
                                    <i className="ri-pencil-fill fs-16" />
                                  </a>
                                </li>
                                <li
                                  className="list-inline-item"
                             
                                  onClick={()=>setshow(true)}
                                  title="Remove"
                                >
                                  <a
                                    className="text-danger d-inline-block remove-item-btn"
                                   
                                  >
                                    <i className="ri-delete-bin-5-fill fs-16" />
                                  </a>
                                </li>
                              </ul>
                            </td> */}

                            <td className="amount">
                            <Dropdown>
      <Dropdown.Toggle variant="transparent" id="dropdown-basic">
        <MoreVert/>
      </Dropdown.Toggle>

      <Dropdown.Menu>
    <Dropdown.Item onClick={() => ({ status: "initiated" })}  ><Pending /> Initiate</Dropdown.Item>
    <Dropdown.Item onClick={() => UpdateRequest({ status: "closed" })} ><Check />Closed</Dropdown.Item>
        <Dropdown.Item href="#/action-3"><Delete/> Delete</Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>  
                                </td>
                          </tr>
  </>
    )
}

export default HackingInternshipRegistrationItem